import React, { useEffect, useState } from 'react'
import loaderImg from "../../../assets/images/ttd/ellipsis.gif";
import { socket } from "../../../socket";
import { btoa } from '../../../cryptographic/crypto'

const Loading = ({ screenName }) => {

    const [counter, setCounter] = useState(0)

    useEffect(() => {
        setTimeout(() => {
            setCounter(prev => prev + 1)
        }, 1000);
        console.log("counter 12", counter)
        if(counter > 4 && screenName === "chatbody"){
            socket.emit(btoa(["user-option", {}]));
            setCounter(0)
        }
    }, [counter])
    return (
        <div className='loading-comp'>
            <img src={loaderImg} alt="Loading..." width={`100px`} />
        </div>
    )
}

export default Loading
